import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import usersReducer from './slices/usersSlice'
import liveSessionsReducer from './slices/sessionSlice'
import assetCacheReducer from './slices/assetCacheSlice'
import networkingReducer from './slices/networkingSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersReducer,
    liveSessions: liveSessionsReducer,
    assetCache: assetCacheReducer,
    networking: networkingReducer,
  },
})

export type AppState = ReturnType<typeof store.getState>

export default store
